import{makeAccessor}from"../core/index.js";export const stepperSize=makeAccessor(["sm","md"]);export const stepperDirection=makeAccessor(["row","column"]);
//# sourceMappingURL=stepper.props.js.map